import { Injectable } from '@angular/core';
import { CartoForm } from "./carto-form";
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartoFormService {

  private cartoForm: CartoForm;

  constructor() { }

  getCartoForm(): CartoForm {
    return this.cartoForm;
  }

  setCartoForm(cartoForm) {
    this.cartoForm = cartoForm;
  }

  reset() {
    this.cartoForm = new CartoForm();
  }

  getObservable(): Observable<any> {
    return of(this.cartoForm);
  }
}
